import { render } from "./scope_selector.vue?vue&type=template&id=0b656441"
import script from "./scope_selector.js?vue&type=script&lang=js&external"
export * from "./scope_selector.js?vue&type=script&lang=js&external"

import "./scope_selector.vue?vue&type=style&index=0&id=0b656441&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__